export const UI_NS = 'ui-v3';

export const UI_SWITCH = `${UI_NS}-switch`;
export const UI_CARD = `${UI_NS}-card`;

export const BASE_AUTOCOMPLETE = `${UI_NS}-base-autocomplete`;
export const FULLTEXT = `${UI_NS}-fulltext`;
export const FULLTEXT_LEFT_ICON = `${UI_NS}-fulltext-left-icon`;
